import { gql } from '@apollo/client';

export default gql`
  query GetReportDownloadUrl($reportId: String!) {
    reportPdfUrl: pdfDownloadUrl(reportId: $reportId)
  }
`;
